<template>
  <div class="form__container">
    <header class="form__container__header">
      <h2 v-html="title" class="form__container__title" />
    </header>

    <div class="form__container__content pt-1">
      <p v-html="text" class="form__container__desc mb-0" />
    </div>
  </div>
</template>

<script>
import { formatNumber } from 'utils/functions'

export default {
  name: 'ErrorBox',
  props: {
    errorType: {
      type: String
    },
    kind: {
      type: String
    },
    maxLines: {
      type: Number,
      default: 1000
    }
  },
  computed: {
    namespace () {
      if (this.errorType === 'maxLines') {
        return 'Views.BulkImportPage.maxLinesError'
      }

      return 'Views.BulkImportPage.emptyFileError'
    },

    type () {
      if (this.kind === 'costCenter') {
        return this.$t('Common.costCenters')
      }

      if (this.kind === 'employee') {
        return this.$t('Common.employees')
      }

      if (this.kind === 'project') {
        return this.$t('Common.projects')
      }

      if (this.kind === 'incentives') {
        return this.$t('Common.incentives')
      }

      if (this.kind === 'approvePayment') {
        return this.$t('Common.charges')
      }

      return ''
    },

    title () {
      return this.replaceText(this.$t(`${this.namespace}.title`))
    },

    text () {
      return this.replaceText(this.$t(`${this.namespace}.text`))
    }
  },
  methods: {
    replaceText (str) {
      return str
        .replace(/\[MAX_LINES\]/g, formatNumber(this.maxLines))
        .replace(/\[TYPE\]/g, this.type.toLowerCase())
    }
  }
}
</script>
